import dom from '../../../wrapper/DomWrapper';

export default () => {
  const elTopSticky = dom.getElement('.top-sticky-block.fixed-block');

  if (!elTopSticky) return 0;

  return dom.getElementHeight(elTopSticky);
};
